import React,{useEffect,useState} from 'react'
import { useDispatch, useSelector } from "react-redux";
import {TextField,Button,CircularProgress} from '@material-ui/core'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import './css/index.css'
import BannerWorkshopYear from '../../assets/image/workshop_year.png'
import Chevron from '../../assets/image/chevron-white.png'
import Close from '../../assets/image/close_grey.svg'
import {getPublicWorkshop} from '../../redux/action/event'
import moment from 'moment'
import Skeleton from 'react-loading-skeleton'
import axios from 'axios'
import {URL,USER,PASS} from '../../service/base_url'
import {get} from 'lodash'
import Modal from '../../components/modal'
import {withRouter} from 'react-router-dom'
function Workshop_year(props) {
    const dispatch=useDispatch()
    const event=useSelector(state=>state.event)
    const general=useSelector(state=>state.general)
    const [state,setState]=useState({
        tabs_mobile_active:0,
        request_form:false,
        success_form:false,
        isOpen: false,
        title:'',
        name:'',
        phoneNumber:'',
        email:'',
        companyName:'',
        loading:false,
        open:false
    })
    useEffect(()=>{
        const {year}=props.match.params
        if(year!==undefined){
            console.log('year', year)
            dispatch(getPublicWorkshop(`/${year}01/${year}12/0`))
        }else{
            dispatch(getPublicWorkshop())
        }
    },[])
    const tabsMobileToggle=(tabs,key)=>{
        setState({...state,tabs_mobile_active:key})
    }
    const toggleRequest=(title)=>{
        setState({...state,request_form:!state.request_form,title})
    }
    const toggleSucces=()=>{
        setState({...state,success_form:!state.success_form})
    }
    const sendForm=()=>{
        setState({...state,request_form:false,success_form:true})
    }
   const onChange=(e)=>{
        e.preventDefault()
        setState({...state,[e.target.name]:e.target.value})
    }
    const submit=(e)=>{
        e.preventDefault()
        setState({...state,loading:true})
        let {name,phoneNumber,email,companyName,title}=state
        axios.post(`${URL}`,{
            name,phoneNumber,email,companyName,action:`eventbrochure-${title}`
        },{
            auth: {
                username: USER,
                password: PASS
              }
        }).then((res)=>{
            if(get(res,'status')==200){
                setState({...state,loading:false})

                setState({...state,success_form:!state.success_form,request_form:!state.request_form})
            }else{
                setState({...state,loading:false})
                alert('Ops something error')
            }
        })
    }
    const children=()=>{
        let {loading}=state
        return(
            <div>
                <p>Please fill out the form below to request a copy of brochure</p>
                <br/>
                <form onSubmit={submit}>
                <TextField
                    label="Name"
                    // label={<p>Name<span style={{color:'red'}}>*</span></p>}
                    variant="outlined"
                    size="small"
                    className='form-request'
                    name='name'
                    onChange={onChange}
                    required
                />
                <br/><br/>
                <TextField
                    label='Email'
                    // label={<p>Email<span style={{color:'red'}}>*</span></p>}
                    variant="outlined"
                    size="small"
                    className='form-request'
                    name='email'
                    onChange={onChange}
                    required
                    type="email"
                />
                <br/><br/>
                <TextField
                    label="Phone No."
                    // label={<p>Phone No.<span style={{color:'red'}}>*</span></p>}
                    variant="outlined"
                    size="small"
                    className='form-request'
                    name='phoneNumber'
                    onChange={onChange}
                    required

                />
                <br/><br/>
                <TextField
                    label="Company name"
                    // label={<p>Company name<span style={{color:'red'}}>*</span></p>}
                    variant="outlined"
                    size="small"
                    className='form-request'
                    name='companyName'
                    onChange={onChange}
                    required
                />
                <br/><br/>
                <Button type='submit' style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">
                    {loading? <CircularProgress size={20} style={{color:'white'}}/>:'Send'}
                </Button>
                </form>
            </div>
        )
    }
    const children2=()=>{
        return(
            <div>
                <p>Thank you for your interest in One GML. we will contact you as soon as possible</p>
                <br/>
                <Button onClick={toggleSucces} style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">Ok</Button>
            </div>
        )
    }
    const loader=()=>{
        return(
            <table width='100%'>
                <thead>
                    <th><Skeleton height={50}/></th>
                    <th><Skeleton height={50}/></th>
                </thead>
                <tbody>
                    <tr>
                        <td><Skeleton height={50}/></td>
                        <td><Skeleton height={50}/></td>
                    </tr>
                    <tr>
                        <td><Skeleton height={50}/></td>
                        <td><Skeleton height={50}/></td>
                    </tr>
                    <tr>
                        <td><Skeleton height={50}/></td>
                        <td><Skeleton height={50}/></td>
                    </tr>
                </tbody>
                
            </table>
        )
    }
    const loaderMobile=()=>{
        return(
            <div className='inyear-content-mobile'>
                <h3 className='color-brown'><Skeleton height={40}/></h3>
                <br/>
                <div className='inyear-card-mobile' >
                    <div className='inyear-card-head'>
                        <p className='color-brown ' style={{fontSize:18}}><Skeleton height={30}/></p>
                    </div>
                    <div className='inyear-card-content'>
                        <table width='100%'>
                            <tr>
                                <td  className='color-brown font-size'><Skeleton height={30}/></td>
                                <td style={{width:20}}></td>
                                <td >
                                <Skeleton height={30}/>
                                <Skeleton height={30}/>
                                </td>
                            </tr>
                            
                        </table>
                    </div>
                    
                </div>
                <br/><br/>
            </div>
        )
    }
    
    return (
        <div>
            <Navbar/>
            <Modal title="Download brochure" isOpen={state.request_form} children={children()} modalToggle={toggleRequest}/>
            <Modal title="Request brochure recorded" isOpen={state.success_form} children={children2()} modalToggle={toggleSucces}/>
            <br/><br/><br/><br/>
            <div className='inyear-header'>
                {/* <div className></div> */}
                <img src={BannerWorkshopYear}/>
                <div className='inyear-header-content'>
                    <div className='badge'>
                        <p ><span style={{cursor:'pointer'}} onClick={()=>window.location.assign('/event-list')}>Event & webinar</span> &nbsp;&nbsp;<span><img src={Chevron}  className='breadcrum-chevron-event'/></span>&nbsp;&nbsp;Public workshop in {props.match.params.year}</p>
                        
                    </div>
                    <div className='detail-title'>
                        <h1>Public workshop in {props.match.params.year}</h1>
                        <br/>
                        <p>Keep up your productivity and enhance your competencies in our public workshops.<br/> All workshops are conducted following strict safety and health practices to build healthy and conducive environment for your learning.</p>
                    </div>
                </div>
            </div>
            <br/>
            
            <div className='inyear-content'>
            <div className='download-section-2' >
                <p onClick={()=>window.open(`/PATHWAY KALENDER 2021.xlsx`,'Download')}>Download as Excel</p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <p onClick={()=>window.open(`/PATHWAY KALENDER 2021.pdf`,'Download')}>Download as PDF</p>
            </div>
            <br/>
            <div  >
            {general.isLoading?loader():event.public_workshop.map((data,i)=>(
            data.item.length>0&&
            <>
            <table className='table-inyear' border="0" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th style={{textAlign:'left',backgroundColor:'white',position:'sticky',display:'flex',alignItems:'center',paddingLeft:10}}>
                            <h3 className='color-brown' style={{fontSize:24}}>Public Workshop {data.branch.text}</h3>
                        </th>
                        <>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Jan</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Feb</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Mar</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Apr</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>May</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Jun</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Jul</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Aug</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Sep</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Oct</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Nov</div>
                        </th>
                        <th className='red-bg table-width'>
                            <div className='color-white div-center'>Dec</div>
                        </th>
                        </>
                    </tr>
                </thead>
                <tbody>
                {data.item.map((data,i)=>(
                
                <tr key={i} >
                    <td style={{width:400}}>
                        <div className='inyear-left-card' >
                            <p className='color-brown font-size'>{data.title}</p>
                        </div>
                    </td>
                    {data.dates.map((a,i)=>(
                            a.dates.length>0?
                            <td className={`border-bottom-inyear`}> 
                            {a.dates.map((b,i)=>(
                                <>
                                <div onClick={()=>toggleRequest(data.title)} className='inyear-date div-center' key={i}>{b.text}</div>
                                </>
                            ))}
                            
                            </td>
                            :
                            <td className={`border-bottom-inyear`}>
                            <div className=' div-center'>
                                <div style={{width:20,height:2,borderRadius:10,backgroundColor:'#eeeeee'}}></div>
                            </div>
                            </td>
                        ))}
                    <br/><br/><br/>
                </tr>
                ))}
                </tbody>
            </table>
            <br/>
            </>
            ))}
            {/* {general.isLoading?loader():event.public_workshop.map((data,i)=>(
            data.item.length>0&&
            <>
            <table width='100%' border="0" cellspacing="0" cellpadding="0" className='table-inyear' >
                <thead  >
                    <tr>
                    <th style={{textAlign:'left',backgroundColor:'white',position:'sticky',display:'flex',alignItems:'center'}}>
                        <h3 className='color-brown' style={{fontSize:24}}>Public Workshop {data.branch.text}</h3>
                    </th>
                    <>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Jan</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Feb</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Mar</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Apr</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Mei</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Jun</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Jul</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Aug</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Sep</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Oct</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Nov</div>
                    </th>
                    <th className='red-bg table-width'>
                        <div className='color-white div-center'>Des</div>
                    </th>
                    </>
                    </tr>
                </thead>
                <tbody cellspacing="0" cellpadding="0">
                
                {data.item.map((data,i)=>(
                
                <tr key={i} style={{height:70}}>
                    <td style={{width:400}}>
                        <div className='inyear-left-card' >
                            <p className='color-brown font-size'>{data.title}</p>
                        </div>
                    </td>
                    {data.dates.map((a,i)=>(
                            a.dates.length>0?
                            <td className={`border-bottom-inyear`}> 
                            {a.dates.map((b,i)=>(
                                <>
                                <div onClick={()=>toggleRequest(data.title)} className='inyear-date div-center' key={i}>{b.text}</div>
                                </>
                            ))}
                            
                            </td>
                            :
                            <td className={`border-bottom-inyear`}>
                            <div className=' div-center'>
                                <div style={{width:20,height:2,borderRadius:10,backgroundColor:'#eeeeee'}}></div>
                            </div>
                            </td>
                        ))}
                    <br/><br/><br/>
                </tr>
                ))}
                </tbody>
            </table>
            <br/>
            </>
            ))} */}
            </div>
            </div>
            {/* {event.public_workshop.map((data,i)=>(
            <div >
           {data.item.length>0&&(

            <div className='inyear-content' style={{maxHeight:400,overflowY:'hidden',overflowX:'hidden'}}>
                <div className='inyear-flex'>
                    <div className='inyear-flex-left'>
                        <h3 className='color-brown'>Public Workshop {data.branch.text}</h3>
                    </div>
                    <div className='inyear-flex-right'>
                        <div className='grid-right red-bg'>
                            <div className='color-white div-center'>Jan</div>
                            <div className='color-white div-center'>feb</div>
                            <div className='color-white div-center'>Mar</div>
                            <div className='color-white div-center'>Apr</div>
                            <div className='color-white div-center'>Mei</div>
                            <div className='color-white div-center'>Jun</div>
                            <div className='color-white div-center'>Jul</div>
                            <div className='color-white div-center'>Aug</div>
                            <div className='color-white div-center'>Sep</div>
                            <div className='color-white div-center'>Oct</div>
                            <div className='color-white div-center'>Nov</div>
                            <div className='color-white div-center'>Des</div>
                        </div>
                    </div>
                </div>
                <div >
                {data.item.map((data,i)=>(
                <div className='inyear-flex' key={i}>
                    <div className='inyear-flex-left '>
                        <div className='inyear-left-card'>
                            <p className='color-brown font-size'>{data.title}</p>
                        </div>
                    </div>
                    <div className='inyear-flex-right'>
                        <div className='grid-right inyear-right-content'>
                            {data.dates.map((a,i)=>(
                                a.dates.length>0?
                                <> 
                                {a.dates.map((b,i)=>(
                                    <div className='inyear-date div-center' key={i}>{b.text}</div>
                                ))}
                                
                                </>
                                :
                                <div className='close-circle div-center'><img src={Close}/></div>
                            ))}
                           
                        </div>
                    </div>
                </div>
                ))}
                </div>
            </div>)}</div>
            ))} */}
            <div className='download-section-2-mobile ' >
                <p onClick={()=>window.open(`/PATHWAY KALENDER 2021.xlsx`,'Download')}>Download as Excel</p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <p onClick={()=>window.open(`/PATHWAY KALENDER 2021.pdf`,'Download')}>Download as PDF</p>
            </div>
            <br/>
            {general.isLoading?loaderMobile():event.public_workshop_mobile.map((data,i)=>(
            data.item.length>0&&
            <div key={i}>
            <div className='inyear-content-mobile'>
                
                <h3 className='color-brown'>Public Workshop {data.branch.text}</h3>
                <br/>
                {data.item.map((item,i)=>(
                <>
                <div className='inyear-card-mobile' key={i}>
                    <div className='inyear-card-head'>
                        <p className='color-brown ' style={{fontSize:18}}>{item.title}</p>
                    </div>
                    <div className='inyear-card-content'>
                        <table width='98%'>
                            {item.dates.map((date,i)=>(
                            <>
                            <tr>
                                <td  className='color-brown font-size'>{moment().month(date[0].id-1).format('MMMM')}</td>
                                <td style={{width:20}}></td>
                                <td style={{display:'flex',width:200,flexWrap:'wrap'}}>
                                <div onClick={()=>toggleRequest(item.title)} className='inyear-date-mobile'>{date[0].text}</div>&nbsp;
                                </td>
                            </tr>
                            <br/>
                            </>
                            ))}
                            {/* <tr>
                                <td className='color-brown font-size'>Februari</td>
                                <td></td>
                                <td style={{display:'flex'}}>
                                    <div className='inyear-date-mobile'>26-30-31</div>
                                </td>
                            </tr> */}
                        </table>
                    </div>
                    
                </div>
                <br/><br/>
                </>
                 ))}
            </div>
            <br/>
            </div>
            ))}
            <Footer/>
        </div>
    )
}
export default withRouter(Workshop_year)